import { FileDownloadModel } from "./FileModels";

export function ConvertAndOpenFile(fileModel: FileDownloadModel) {
    let binary_string = window.atob(fileModel.Data);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);

    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }

    let blob = new Blob([bytes.buffer], { type: fileModel.Type });

    let a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);

    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileModel.Name;
    a.click(); //Trigger download

    //release the reference to the file and remove element from body
    window.URL.revokeObjectURL(url);
    a.remove();
}

//Add the data to a form for Multipart Post - This is necessary for sending large payloads with our firewall
//Supports data models with types: primitives, File, object (primitives, 1 layer deep), array (primitive and 1 layer deep objects)
//ignoredKeys only works on top level properties
export function CreateFormData(dataObject: any, imageKeys: string[] = []): FormData {
    let dataForm = new FormData();

    for (var key in dataObject) {
        let value = (dataObject as any)[key];
        if (dataObject.hasOwnProperty(key) && value != null) {
            if (value instanceof File) { //File
                dataForm.append(key, value, (value as File).name);
            } else if (Array.isArray(value)) { //Array
                //Append lists as flat data
                if ((value as []).length == 0) {
                    //skip
                } else if (typeof value[0] === 'object') {
                    //Array of objects
                    (value as []).forEach((val: any, i: number) => {
                        for (var arrayKey in val) {
                            let arrayValue = (val as any)[arrayKey];
                            if (val.hasOwnProperty(arrayKey) && arrayValue != null) {
                                if (imageKeys.indexOf(arrayKey) != -1)
                                    dataForm.append(key + "[" + i + "]." + arrayKey + "Upload", new File([arrayValue], arrayKey + '.txt', { type: "text/plain", }), arrayKey + ".txt");
                                else
                                    dataForm.append(key + "[" + i + "]." + arrayKey, arrayValue);
                            }
                        }
                    });
                } else {
                    if (imageKeys.indexOf(key) != -1) {
                        //Array of images
                        (value as []).forEach((val, i) => {
                            dataForm.append(key + "Upload", new File([val], key + i + '.txt', { type: "text/plain", }), key + i + '.txt');
                        });
                    } else {
                        //Simple array
                        (value as []).forEach((val, i) => {
                            dataForm.append(key + "[" + i + "]", val);
                        });
                    }
                }
            } else if (typeof value === 'object') { //Object
                //Keys of primitives in object
                for (var objectKey in value) {
                    let objectValue = (value as any)[objectKey];
                    if (value.hasOwnProperty(objectKey) && objectValue != null) {
                        dataForm.append(key + "." + objectKey, objectValue);
                    }
                }
            } else { //Anything else
                if (imageKeys.indexOf(key) != -1)
                    dataForm.append(key + "Upload", new File([value], key + '.txt', { type: "text/plain", }), key + '.txt');
                else
                    dataForm.append(key, value);
            }
        }
    }

    return dataForm;
}